import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateClassificationMutation as UpdateClassificationMutationType,
  UpdateClassificationMutationVariables,
} from "./__generated__/UpdateClassificationMutation";

const UpdateClassificationMutation = loader("./UpdateClassificationMutation.gql");

type UpdateClassificationMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateClassificationMutationType) => void;
}) => ReactElement;

export const UpdateClassificationMutationProvider: UpdateClassificationMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateClassificationMutationType, UpdateClassificationMutationVariables>(
    UpdateClassificationMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
